import * as React from 'react'
import MUICard from '@mui/material/Card'

const Card = (props) => <MUICard {...props} />

export default Card
